module.exports = __webpack_public_path__ + "img/logo.cc0faf6b.png";